// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountsController from "./accounts_controller"
application.register("accounts", AccountsController)

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BookingFormController from "./booking_form_controller"
application.register("booking-form", BookingFormController)

import Bookings__CalendarController from "./bookings/calendar_controller"
application.register("bookings--calendar", Bookings__CalendarController)

import BusinessHoursController from "./business_hours_controller"
application.register("business-hours", BusinessHoursController)

import CallyController from "./cally_controller"
application.register("cally", CallyController)

import DetailsController from "./details_controller"
application.register("details", DetailsController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ElementRemovalController from "./element_removal_controller"
application.register("element-removal", ElementRemovalController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormController from "./form_controller"
application.register("form", FormController)

import GeocoderController from "./geocoder_controller"
application.register("geocoder", GeocoderController)

import Home__AutocompleteController from "./home/autocomplete_controller"
application.register("home--autocomplete", Home__AutocompleteController)

import Home__SearchController from "./home/search_controller"
application.register("home--search", Home__SearchController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import MapInlayController from "./map_inlay_controller"
application.register("map-inlay", MapInlayController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import Onboarding__SigningFormsController from "./onboarding/signing_forms_controller"
application.register("onboarding--signing-forms", Onboarding__SigningFormsController)

import Onboarding__TermsModalController from "./onboarding/terms_modal_controller"
application.register("onboarding--terms-modal", Onboarding__TermsModalController)

import Pages__HomeController from "./pages/home_controller"
application.register("pages--home", Pages__HomeController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import Providers__WeekCalendarController from "./providers/week_calendar_controller"
application.register("providers--week-calendar", Providers__WeekCalendarController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import ScrollToElementController from "./scroll_to_element_controller"
application.register("scroll-to-element", ScrollToElementController)

import Search__FiltersController from "./search/filters_controller"
application.register("search--filters", Search__FiltersController)

import Search__ListController from "./search/list_controller"
application.register("search--list", Search__ListController)

import Search__MapController from "./search/map_controller"
application.register("search--map", Search__MapController)

import SigningWindowController from "./signing_window_controller"
application.register("signing-window", SigningWindowController)


import Spaces__FormController from "./spaces/form_controller"
application.register("spaces--form", Spaces__FormController)

import TestimonialController from "./testimonial_controller"
application.register("testimonial", TestimonialController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ToggleClassesController from "./toggle_classes_controller"
application.register("toggle-classes", ToggleClassesController)

import TransitionController from "./transition_controller"
application.register("transition", TransitionController)
